import { createReducer, on } from '@ngrx/store';
import { VociActions } from './voci.actions';
import { Voce } from '../../core/models/voci.model';

export interface VociState {
  items: Voce[];
  loading: boolean;
  error: string | null;

  selected: Voce | null;

  opLoading: boolean;
  opError: string | null;
}

export const initialState: VociState = {
  items: [],
  loading: false,
  error: null,

  selected: null,

  opLoading: false,
  opError: null,
};

// Helper per confronti sicuri tra ID
const toId = (v: unknown) => String(v ?? '');

export const vociReducer = createReducer(
  initialState,

  on(VociActions.loadByCapitoloId, (s) => ({ ...s, loading: true, error: null })),
  on(VociActions.loadByCapitoloIdSuccess, (s, { items }) => ({
    ...s,
    loading: false,
    items,
  })),
  on(VociActions.loadByCapitoloIdFailure, (s, { error }) => ({ ...s, loading: false, error })),

  on(VociActions.loadDetails, (s) => ({ ...s, opLoading: true, opError: null })),
  on(VociActions.loadDetailsSuccess, (s, { item }) => ({ ...s, opLoading: false, selected: item })),
  on(VociActions.loadDetailsFailure, (s, { error }) => ({ ...s, opLoading: false, opError: error })),

  on(VociActions.create, (s) => ({ ...s, opLoading: true, opError: null })),
  on(VociActions.createSuccess, (s) => ({ ...s, opLoading: false })),
  on(VociActions.createFailure, (s, { error }) => ({ ...s, opLoading: false, opError: error })),

  on(VociActions.update, (s) => ({ ...s, opLoading: true, opError: null })),
  on(VociActions.updateSuccess, (s, { id }) => ({
    ...s,
    opLoading: false,
    // Non aggiorniamo items/selected perché abbiamo solo l'ID, faremo il reload
  })),
  on(VociActions.updateFailure, (s, { error }) => ({ ...s, opLoading: false, opError: error })),

  on(VociActions.delete, (s) => ({ ...s, opLoading: true, opError: null })),
  on(VociActions.deleteSuccess, (s, { id }) => ({
    ...s,
    opLoading: false,
    items: s.items.filter((x) => toId(x.id) !== toId(id)),
    selected: toId(s.selected?.id) === toId(id) ? null : s.selected,
  })),
  on(VociActions.deleteFailure, (s, { error }) => ({ ...s, opLoading: false, opError: error })),

  on(VociActions.deleteSuggestion, (s) => ({ ...s, opLoading: true, opError: null })),
  on(VociActions.deleteSuggestionSuccess, (s) => ({ ...s, opLoading: false })),
  on(VociActions.deleteSuggestionFailure, (s, { error }) => ({ ...s, opLoading: false, opError: error })),
);